module.exports = __webpack_public_path__ + "img/dashboard_2.e6dde0c2.jpg";